import LocalizedStrings from "react-localization";
import es from "./es.js";
import en from "./en.js";

const strings = new LocalizedStrings(
  {
    en,
    es,
  },
  {
    logsEnabled: false,
  },
);

const getBrowserLanguage = () => {
  let lang = null;
  if (navigator?.length) {
    lang = navigator.languages[0];
  } else {
    lang =
      navigator.userLanguage ||
      navigator.language ||
      navigator.browserLanguage ||
      "es";
  }
  return lang.match(/(\w+)/)[0];
};

const get_language = strings.getLanguage();

const set_language = (lang) => {
  strings.setLanguage(lang);
};

const interface_lang = strings.getInterfaceLanguage();

const browser_language = getBrowserLanguage();

const set_browser_language = () => {
  strings.setLanguage(browser_language);
};

const translate = (message = "", ...args) => {
  let trans = "";
  if (strings.getLanguage() === "es") {
    if (args && args.length > 0) {
      return strings.formatString(message, ...args);
    }
    return message;
  }
  trans = strings[message];
  if (!trans || trans === "") {
    trans = message;
  }
  if (args && args.length > 0) {
    const tArgs = args.map((i) => (strings[i] ? strings[i] : i));
    trans = strings.formatString(trans, ...tArgs);
  }
  return trans;
};

if (localStorage.getItem("lang")) {
  set_language(localStorage.getItem("lang"));
} else {
  set_language(browser_language);
}

export {
  strings,
  get_language,
  set_language,
  interface_lang,
  browser_language,
  set_browser_language,
  translate,
};
